import styled from 'styled-components';

import { EmbeddedMessageMedium, WhatsAppMedium } from 'constants/messageMediums';
import { getRelativeTimeInfo } from 'modules/templateEditor/common/utils';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { Avatar, AVATAR_SIZES } from 'ui/avatar';
import { Caption, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { useEditorViewLoader } from '../../hooks/useEditorViewLoader';
import { InStudioView } from '../enums';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing.half};
`;

const LastModifiedWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LastModified = () => {
  const { isLoading } = useEditorViewLoader(InStudioView.Preview);
  const { liveTemplate, selectedMessageMedium } = useEditableFieldsContext();

  const modifiedDate = liveTemplate?.updatedAt || liveTemplate?.createdAt;
  // NOTE: relTime is displayed in the UI, so do not define the locale (the locale of the browser will be used)
  const relTime = getRelativeTimeInfo(modifiedDate);

  const modifier = liveTemplate?.updatedByUser || {};
  const MODIFIER_NAME_ARRAY = modifier?.fullName?.split(' ') || [];
  const user = {
    firstName: MODIFIER_NAME_ARRAY[0] || '',
    lastName: MODIFIER_NAME_ARRAY[MODIFIER_NAME_ARRAY.length - 1] || '',
    imgUrl: modifier?.avatarUrl || '',
  };

  return (
    <Wrapper data-test={'last-modified-wrapper'}>
      <Caption>
        {/* Hide message type name when medium is embedded (WF-7353) */}
        {selectedMessageMedium !== EmbeddedMessageMedium.Embedded &&
        selectedMessageMedium !== WhatsAppMedium.WhatsApp
          ? liveTemplate?.messageType?.name
          : ''}
      </Caption>
      {!isLoading && (
        <LastModifiedWrapper data-test={'last-modified-text'}>
          <Caption>
            Last edited{' '}
            <Tooltip isUnderlined tooltipContent={relTime.tooltip}>
              {relTime.label}
            </Tooltip>{' '}
            by{' '}
          </Caption>
          <Avatar
            data-test={`${user.firstName}-${user.lastName}`}
            firstName={user.firstName}
            lastName={user.lastName}
            imgSrc={user.imgUrl}
            size={AVATAR_SIZES.SMALL}
            style={{ marginLeft: spacing.quarter }}
          />
        </LastModifiedWrapper>
      )}
    </Wrapper>
  );
};
